import validator from "@/generated/validators/ValidationRules";
import {Period} from "@/framework/base/helpers/DateFormat";
import { MapRessource } from '@/framework/base/helpers/Ressources';
import { upperCase, lowerCase, ascii, asciiLowerCase } from '@/framework/base/helpers/String';
import { Alerts } from '@/framework/base/helpers/Alerts';

export enum EditFieldTheme {
  BASIC,
  OUTLINED,
  SINGLE_LINE
}
export enum EditFieldType {
  NONE,
  STRING,
  INT,
  DECIMAL,
  DATE,
  TIME,
  CURRENCY,
  BOOL,
  CHOIX,
  SUMMARY,
  EDITLINK,
  SELECT,
  HTMLATTRIB,
  HTML,
  IDENTIFIANT,
  IMAGE,
  PERCENTAGE,
  PHONE
}

export interface Mask {
  (value: string): string;
}

export interface Format {
  (value: string): string;
}

export interface LiveValidator {
  (value: string): validator | null;
}

export interface FocusValidator {
  (value: string): validator | null;
}

export class FieldInfo {
  theme: EditFieldTheme;
  ressource: MapRessource;
  mask: Mask | null;
  type: EditFieldType;
  precision: number;
  format: Format | null;
  focusValidator: FocusValidator | null;
  liveValidator: LiveValidator | null;
  compare: (value: string | number | undefined, limit: boolean) => number | undefined;
  valid: (value: string, periods: Period[]) => boolean;

  constructor(
    ressource: MapRessource,
    type: EditFieldType,
    precision: number,
    mask: Mask | null,
    format: Format | null,
    focusValidator: FocusValidator | null,
    liveValidator: LiveValidator | null,
    theme: EditFieldTheme = EditFieldTheme.BASIC,
  ) {
    this.ressource = ressource;
    this.type = type;
    this.precision = precision;
    this.mask = mask;
    this.format = format;
    this.focusValidator = focusValidator;
    this.liveValidator = liveValidator;
    this.theme = theme;
  }

  public static fromJson (obj: FieldInfo): FieldInfo {
    const newFieldInfo: FieldInfo = new FieldInfo(obj.ressource, obj.type, obj.precision, obj.mask, obj.format, obj.focusValidator, obj.liveValidator, obj.theme);
    newFieldInfo.compare = obj.compare;
    return newFieldInfo;
  }

}

export class FieldValue {
  range: number;
  table: string;
  value: string | number | boolean | Date | null;
  rules: validator[];
  constructor(r: number, t: string, v: string | number | boolean | Date | null, val: validator[]) {
    this.range = r;
    this.table = t;
    this.value = v;
    this.rules = val;
  }
}
export class FieldError {
  range: number;
  table: string;
  error: boolean;
  constructor(r: number, t: string, e: boolean) {
    this.range = r;
    this.table = t;
    this.error = e;
  }
}

export class FieldStatus {
  // données saisies invalide
  public error: boolean;
  // champ modifié
  public updated: boolean;
  // id for list of objects
  public objId: number;

  constructor(error: boolean, updated: boolean, objId: number) {
    this.error = error;
    this.updated = updated;
    this.objId = objId;
  }
  public clear (id: number): void {
    this.error = false;
    this.updated = false;
    this.objId = id;
  }
}

export class SectionStatus {
  // données saisies invalide
  public error: boolean;
  // champ modifié
  public updated: boolean;
  // id for list of objects
  public missing: boolean;

  constructor(error: boolean, updated: boolean, missing: boolean) {
    this.error = error;
    this.updated = updated;
    this.missing = missing;
  }
  public clear (): void {
    this.error = false;
    this.updated = false;
    this.missing = false;
  }
}
export function getFormat (value: string): Format | null {
  if (value == 'UPPERCASE') {
    return upperCase;
  }
  else if (value == 'LOWERCASE') {
    return lowerCase;
  }
  else if (value == 'ASCII') {
    return ascii;
  }
  else if (value == 'MAIL') {
    return asciiLowerCase;
  }
  else if (value != '') {
    Alerts.debug('getFormat : format inconnu ' + value);
  }
  return null;
}

